import React from 'react';
import { Outlet } from 'react-router-dom';
import './I3Coaching.css';

/** Standalone public site — no proposal password; intro + video in I3Shell. */
const I3CoachingLayout: React.FC = () => <Outlet />;

export default I3CoachingLayout;
